export default __webpack_public_path__ + "static/media/1xYear.5756fe26.png";